// extracted by mini-css-extract-plugin
export var playAnywhereBenefitCopy = "XboxPlayAnywhereSection-module__playAnywhereBenefitCopy___SR182";
export var playAnywhereSection = "XboxPlayAnywhereSection-module__playAnywhereSection___2-yxn";